import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {LocalCustodiansAddEditComponent} from '@app/admin/local-custodians/local-custodians-add-edit/local-custodians-add-edit.component';

@Component({
  selector: 'app-local-custodians-dialog',
  templateUrl: './local-custodians-dialog.component.html',
  styleUrls: ['./local-custodians-dialog.component.scss']
})
export class LocalCustodiansDialogComponent implements OnInit {
  public _formValid = false;
  @ViewChild('localcustodians') localcustodians: LocalCustodiansAddEditComponent;
  constructor(@Inject(MAT_DIALOG_DATA)
              public data: any,
              private dialogRef: MatDialogRef<LocalCustodiansDialogComponent>) {
  }

  ngOnInit() {
  }

  setFormValidation(valid) {
    this._formValid = valid;
  }

  formSaved(flag) {
    this.dialogRef.close(flag);
  }

  onClickReset() {
    this.localcustodians.reset();
  }
}
